import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import Categories from './pages/Categories.jsx';
import ProductDetail from './pages/ProductDetail.jsx';
import Cart from './pages/Cart.jsx';
import Checkout from './pages/Checkout.jsx';

const COLORS = { black: '#0A0A0A', white: '#F5F5F0' };

function NotFound() {
  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: COLORS.white,
      fontFamily: 'Inter, system-ui, sans-serif',
      gap: '1rem',
    }}>
      <h1 style={{ fontSize: '5rem', margin: 0, fontWeight: 900 }}>404</h1>
      <p style={{ margin: 0, opacity: 0.6 }}>This page doesn't exist. Yet.</p>
      <a href="/" style={{ color: '#C9A84C', textDecoration: 'none', letterSpacing: '0.1em', fontSize: '0.85rem' }}>
        BACK TO QRQY
      </a>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* All routes share the Layout wrapper */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="shop" element={<Categories />} />
          <Route path="shop/:slug" element={<ProductDetail />} />
          <Route path="cart" element={<Cart />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
